import styled from 'styled-components';

export const CardContentStyle = {
  display: 'flex',
  width: '100%',
  margin: 'auto',
  alignItems: 'center',
  paddingTop: '.5rem',
  paddingBottom: '.5rem',
};

export const DocumentContainer = styled.a`
  cursor: pointer;
  text-decoration: none;
`;

export default {
  CardContentStyle,
  DocumentContainer,
};
